// extracted by mini-css-extract-plugin
export default {"container":"k3IcYg3dFK5XPn3tLPqg"};